import { useEffect, useRef } from 'react';

const stats = [
  { value: '100%', label: 'iOS Native' },
];

export default function AboutSection() {
  const sectionRef = useRef<HTMLElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.querySelectorAll<HTMLElement>('[data-animate]').forEach((el, i) => {
              setTimeout(() => {
                el.style.opacity = '1';
                el.style.transform = 'translateY(0)';
              }, i * 120);
            });
          }
        });
      },
      { threshold: 0.2 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section id="about" ref={sectionRef} className="py-28 md:py-36 bg-white">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="flex flex-col lg:flex-row gap-16 lg:gap-24 items-start">

          {/* Left — Text */}
          <div className="flex-1">
            <p
              data-animate
              className="text-xs font-semibold tracking-widest uppercase text-emerald-600 mb-6 transition-all duration-700"
              style={{ opacity: 0, transform: 'translateY(20px)' }}
            >
              Who We Are
            </p>
            <h2
              data-animate
              className="text-4xl md:text-5xl lg:text-6xl font-thin text-gray-900 leading-tight mb-10 transition-all duration-700"
              style={{ opacity: 0, transform: 'translateY(24px)' }}
            >
              A team of
              <br />
              <strong className="font-semibold">dedicated experts</strong>
              <br />
              for iOS.
            </h2>
            <p
              data-animate
              className="text-lg text-gray-500 leading-relaxed max-w-lg transition-all duration-700"
              style={{ opacity: 0, transform: 'translateY(20px)' }}
            >
              DURID d.o.o. is a team of experts developing modern applications
              for the iOS platform. Our products are designed to enhance user
              experience and improve the security of mobile devices — giving you
              confidence and control in a connected world.
            </p>
            <p
              data-animate
              className="mt-6 text-lg text-gray-500 leading-relaxed max-w-lg transition-all duration-700"
              style={{ opacity: 0, transform: 'translateY(20px)' }}
            >
              We believe great software is invisible — it just works, keeps you
              safe, and never gets in the way of your day.
            </p>
          </div>

          {/* Right — Stats Card */}
          <div
            data-animate
            className="lg:w-80 w-full lg:mt-20 transition-all duration-700"
            style={{ opacity: 0, transform: 'translateY(28px)' }}
          >
            <div className="rounded-3xl bg-gray-50 p-10 flex flex-col gap-10">
              {stats.map((stat) => (
                <div key={stat.label} className="flex flex-col gap-1">
                  <span className="text-5xl font-bold text-gray-900 leading-none">{stat.value}</span>
                  <span className="text-sm text-gray-400 font-medium mt-1">{stat.label}</span>
                </div>
              ))}
            </div>
          </div>

        </div>
      </div>
    </section>
  );
}
